import {
  Component,
  OnInit,
  ViewChild,
  AfterViewInit,
  ElementRef,
  ViewEncapsulation,
} from '@angular/core';
import { Params } from '@angular/router';
import { toggleTimeline } from '../../utils/toggleTimeline';
import { JsonKey } from 'src/app/data/type/locale-copy-key';
import { getNavigationCopy } from 'src/app/utils/localization';
import { LocalizationService } from 'src/app/service/localization.service';
import { RoutePath } from 'src/app/app-routing.module';
import gsap from 'gsap';
import { ParameterService } from 'src/app/service/parameter.service';
import { Parameter } from 'src/app/data/type/parameter';
import { triggerEvent, AnalyticsEvent } from 'src/app/utils/analytics';
import { TvFeature } from 'src/app/data/enum/tv-feature';
import { CompareButtonLocation } from '../atoms/a02-comparison-button/a02-comparison-button.component';
import { ModalService } from 'src/app/service/modal.service';

const localEvents = {
  [TvFeature.BROWSE_TITLES]: AnalyticsEvent.browseTitlesPage,
  [TvFeature.RECOMMENDATIONS]: AnalyticsEvent.recommendationsPage,
  [TvFeature.VOICE]: AnalyticsEvent.voicePage,
  [TvFeature.WATCHLIST]: AnalyticsEvent.watchlistPage,
};

@Component({
  selector: 'app-s01-navigation',
  templateUrl: './s01-navigation.component.html',
  styleUrls: ['./s01-navigation.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class S01NavigationComponent implements OnInit, AfterViewInit {
  @ViewChild('linksModalRef') linksModalRef: ElementRef;
  @ViewChild('hamburgerButtonRef') hamburgerButtonRef: ElementRef;

  public readonly jsonKey = JsonKey;
  public isOpen: boolean = false;
  public modalTimeline: GSAPTimeline = gsap.timeline({ paused: true, id: 's01-nav-timeline' });
  public modalelement: HTMLDivElement | null;
  public compareButtonLocation = CompareButtonLocation.nav;
  public modalElement: HTMLDivElement | null;
  public showCompareButton =
    this.parameterService.getParam(Parameter['disable-compare']) !== 'true';

  public copy = {
    [JsonKey.NAVIGATION_LINK_1]: '',
    [JsonKey.NAVIGATION_LINK_2]: '',
    [JsonKey.NAVIGATION_LINK_3]: '',
    [JsonKey.NAVIGATION_LINK_4]: '',
    [JsonKey.NAVIGATION_OPEN_ARIA_LABEL]: '',
    [JsonKey.NAVIGATION_CLOSE_ARIA_LABEL]: '',
  };

  public links: Array<{ link: string; copy: string; isActive: boolean; feature: TvFeature }> = [];
  public params: Params;

  constructor(
    private localizationService: LocalizationService,
    private parameterService: ParameterService,
    private modalService: ModalService,
  ) {
    this.params = this.parameterService.getParams();
  }

  ngOnInit(): void {
    this.copy = getNavigationCopy(this.localizationService);

    const localizedLinks = {
      browseTitles: this.localizationService.getLocalizedLink(RoutePath['browse-titles']),
      recommendations: this.localizationService.getLocalizedLink(RoutePath['recommendations']),
      watchlist: this.localizationService.getLocalizedLink(RoutePath['watchlist']),
      voiceSearch: this.localizationService.getLocalizedLink(RoutePath['voice-search']),
    };

    this.links = [
      {
        link: localizedLinks.browseTitles,
        copy: this.copy[JsonKey.NAVIGATION_LINK_1],
        isActive: !!location.pathname.match(RoutePath['browse-titles']),
        feature: TvFeature.BROWSE_TITLES,
      },
      {
        link: localizedLinks.recommendations,
        copy: this.copy[JsonKey.NAVIGATION_LINK_2],
        isActive: !!location.pathname.match(RoutePath.recommendations),
        feature: TvFeature.RECOMMENDATIONS,
      },
      {
        link: localizedLinks.watchlist,
        copy: this.copy[JsonKey.NAVIGATION_LINK_3],
        isActive: !!location.pathname.match(RoutePath.watchlist),
        feature: TvFeature.WATCHLIST,
      },
      {
        link: localizedLinks.voiceSearch,
        copy: this.copy[JsonKey.NAVIGATION_LINK_4],
        isActive: !!location.pathname.match(RoutePath['voice-search']),
        feature: TvFeature.VOICE,
      },
    ];
  }

  ngAfterViewInit(): void {
    this.modalService.setClosingFocusTarget(this.hamburgerButtonRef.nativeElement);

    this.modalElement = this.linksModalRef.nativeElement;
    gsap.set(this.modalElement, { x: '-100%' });

    this.setupTimeline();
  }

  setupTimeline() {
    const modalChildrenSelector = gsap.utils.selector(this.modalElement);

    const navAnchorElements = modalChildrenSelector('.nav-anchor');
    const compareButonElement = modalChildrenSelector('.compare-button-wrapper');

    if (this.modalTimeline) {
      this.modalTimeline
        .to(this.modalElement, { x: 0, duration: 1.5 }, 0)
        .from(
          [navAnchorElements, compareButonElement],
          { autoAlpha: 0, x: -30, stagger: 0.1 },
          '-=0.5',
        );
    }
  }

  public onMenuButtonClick() {
    if (!gsap.isTweening(this.modalTimeline)) {
      this.isOpen = !this.isOpen;
      toggleTimeline(this.isOpen, this.modalTimeline);
      triggerEvent(this.isOpen ? AnalyticsEvent.menuOpen : AnalyticsEvent.menuClosed);
    }
  }

  handleLinkClick(feature: TvFeature) {
    triggerEvent(localEvents[feature]);
  }
}
